// extracted by mini-css-extract-plugin
export default {"container":"Ly-z","contactUsLink":"My-z"};